import React from 'react'

export const NoteDeleteIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="14" viewBox="0 0 13 14" fill="none">
    <path d="M12 3.43056C9.965 3.22889 7.91778 3.125 5.87667 3.125C4.66667 3.125 3.45667 3.18611 2.24667 3.30833L1 3.43056" stroke="#BA6B73" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M4.35938 2.815L4.49382 2.01444C4.5916 1.43389 4.66493 1 5.69771 1H7.29882C8.3316 1 8.41104 1.45833 8.50271 2.02056L8.63715 2.815" stroke="#BA6B73" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M10.6847 5.36328L10.2875 11.5171C10.2203 12.4766 10.1653 13.2221 8.46028 13.2221H4.53694C2.83194 13.2221 2.77694 12.4766 2.70972 11.5171L2.3125 5.36328" stroke="#BA6B73" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M5.48047 9.85938H7.51547" stroke="#BA6B73" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M4.97266 7.41797H8.02821" stroke="#BA6B73" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  )
}
